import { struct } from 'io-ts/Decoder';

import { Id as JobId } from '../job/Id';

import { Id as TransactionId } from './Id';

export const ComplexId = struct({
	jobId: JobId,
	transactionId: TransactionId,
});
